import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "dc-num-value" }
const _hoisted_2 = { class: "dc-num-unit" }
const _hoisted_3 = { class: "dc-num-label" }

import { ref, onMounted, onUnmounted } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'DemoCelebrationV3',
  emits: ["install", "explore", "replay"],
  setup(__props) {

/* eslint-disable no-undef */


const recapItems = [
  'Live dashboard with customer insights',
  'Top customers ranked by value',
  'AI-written emails & SMS for each customer',
  'Smart scheduling & timing',
  'Behavior-triggered targeting',
  'Editable templates you control'
];

const stats = [
  { end: 32, suffix: '%', prefix: '', label: 'Avg. revenue lift' },
  { end: 4.2, suffix: 'x', prefix: '', label: 'More repeat buyers' },
  { end: 68, suffix: '%', prefix: '', label: 'Cart recovery' },
  { end: 2, suffix: ' min', prefix: '', label: 'Setup time' }
];

const mounted = ref(false);
const stage = ref(0);
const counting = ref(false);
const animatedValues = ref(stats.map(() => 0));

let timers: ReturnType<typeof setTimeout>[] = [];

function animateCounters() {
  counting.value = true;
  const dur = 1000;
  const steps = 36;
  const iv = dur / steps;
  let step = 0;

  const t = setInterval(() => {
    step++;
    const eased = 1 - Math.pow(1 - step / steps, 3);
    animatedValues.value = stats.map((s) => {
      const v = s.end * eased;
      return s.suffix === 'x' || s.suffix === 'min'
        ? Math.round(v * 10) / 10
        : Math.round(v);
    });
    if (step >= steps) {
      clearInterval(t);
      animatedValues.value = stats.map((s) => s.end);
      counting.value = false;
    }
  }, iv);
}

onMounted(() => {
  mounted.value = true;
  [80, 400, 850, 1350, 1900].forEach((ms, i) => {
    const t = setTimeout(() => {
      stage.value = i + 1;
      if (i === 3) animateCounters();
    }, ms);
    timers.push(t);
  });
});

onUnmounted(() => timers.forEach(clearTimeout));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["dc", { 'dc--visible': mounted.value }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["dc-success", { show: stage.value >= 1 }])
    }, [...(_cache[3] || (_cache[3] = [
      _createElementVNode("div", { class: "dc-check-ring" }, [
        _createElementVNode("svg", {
          class: "dc-check-svg",
          viewBox: "0 0 52 52"
        }, [
          _createElementVNode("circle", {
            class: "dc-check-circle",
            cx: "26",
            cy: "26",
            r: "24"
          }),
          _createElementVNode("path", {
            class: "dc-check-path",
            d: "M15 26l7 7 15-15"
          })
        ])
      ], -1)
    ]))], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["dc-hero", { show: stage.value >= 2 }])
    }, [...(_cache[4] || (_cache[4] = [
      _createElementVNode("h1", { class: "dc-h1" }, [
        _createTextVNode("Ready to run this on "),
        _createElementVNode("em", null, "your"),
        _createTextVNode(" store?")
      ], -1),
      _createElementVNode("p", { class: "dc-lead" }, " Everything you just saw works out of the box on Shopify. Install the app, connect your catalog, and the AI starts reaching your customers — no credit card, no setup call. ", -1)
    ]))], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["dc-recap", { show: stage.value >= 3 }])
    }, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(recapItems, (item, i) => {
        return _createElementVNode("div", {
          class: "dc-recap-item",
          key: i,
          style: _normalizeStyle({ transitionDelay: `${i * 0.06}s` })
        }, [
          _cache[5] || (_cache[5] = _createElementVNode("span", { class: "dc-recap-check" }, "✓", -1)),
          _createElementVNode("span", null, _toDisplayString(item), 1)
        ], 4)
      }), 64))
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["dc-numbers", { show: stage.value >= 4 }])
    }, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(stats, (s, i) => {
        return _createElementVNode("div", {
          class: "dc-num",
          key: i
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createTextVNode(_toDisplayString(counting.value ? animatedValues.value[i] : s.end), 1),
            _createElementVNode("span", _hoisted_2, _toDisplayString(s.suffix), 1)
          ]),
          _createElementVNode("div", _hoisted_3, _toDisplayString(s.label), 1)
        ])
      }), 64))
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["dc-cta", { show: stage.value >= 5 }])
    }, [
      _createElementVNode("button", {
        class: "dc-install",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('install')))
      }, [...(_cache[6] || (_cache[6] = [
        _createTextVNode(" Install on Shopify — Free ", -1),
        _createElementVNode("span", { class: "dc-arrow" }, "→", -1)
      ]))]),
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "dc-meta" }, "No credit card · 2 min setup · Cancel anytime", -1))
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["dc-bottom", { show: stage.value >= 5 }])
    }, [
      _createElementVNode("button", {
        class: "dc-link",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('explore')))
      }, "Keep exploring"),
      _createElementVNode("button", {
        class: "dc-link",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('replay')))
      }, "Replay tour")
    ], 2)
  ], 2))
}
}

})